import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=0c598164&scoped=true"
import script from "./RecordDetails.vue?vue&type=script&lang=js"
export * from "./RecordDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c598164",
  null
  
)

export default component.exports